import { mapGetters } from 'vuex'

export default {
  name: 'OfferItem',
  components: {},
  props: ['plan'],
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'selectedPlan'
    ])
  },
  mounted () {

  },
  methods: {
    selectPlan (navigate) {
      this.$store.dispatch('selectPlan', { amount: this.plan.amount, description: this.plan.description })
      if (navigate) {
        this.$router.go(-1)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/OfferItem/component.js